
export const venuesListData = [
  {
    name: '下北沢 SOUND DOOR',
    capacity: '約150名',
    access: '下北沢駅 徒歩6分',
    note: 'PA常備、ドリンク代別',
    url: 'https://example-sounddoor.tokyo',
  },
  {
    name: '吉祥寺 MOONLIGHT',
    capacity: '約120名',
    access: '吉祥寺駅 徒歩8分',
    note: '学割あり',
    url: 'https://example-moonlight.tokyo',
  },
  {
    name: '恵比寿 BRICK',
    capacity: '約300名',
    access: '恵比寿駅 徒歩7分',
    note: '照明オプションあり',
    url: 'https://example-brick.tokyo',
  },
  {
    name: '渋谷 LIGHTHOUSE',
    capacity: '約250名',
    access: '渋谷駅 徒歩10分',
    note: '集客サポートあり',
    url: 'https://example-lighthouse.tokyo',
  },
  {
    name: '六本木 BEAT HALL',
    capacity: '約180名',
    access: '六本木駅 徒歩5分',
    note: '深夜営業可',
    url: 'https://example-beathall.tokyo',
  },
];
